var _ = require('lodash');
var React = require('react');
var Reflux = require('reflux');

var storyScenarios = require('models/storyScenarios');

var ScrollSpyContentsMixin = require('views/scrollSpy/ScrollSpyContentsMixin');

var SCROLLSPY_PROPS = {
  id: 'scenario-credits',
  name: 'Credits'
}

module.exports = React.createClass({displayName: "module.exports",
  mixins: [ScrollSpyContentsMixin],

  getInitialState:function() {
    return {
      scrollSpy: SCROLLSPY_PROPS
    };
  },

  componentDidMount: function() {
    $('#datahero2').tooltip();
  },

  onScrollSpyFocus: function(target) {
    actions.chart.selectMeasure('values');
    actions.exit.changeValuation(storyScenarios.rounds.exit, 1000000000);
    actions.round.setScenario(storyScenarios.rounds.exit);
    actions.chart.selectRound(null);
  },

  render:function() {
    return (
      React.createElement("div", {id: SCROLLSPY_PROPS.id}, 
        React.createElement("h1", {className: this.state.scrollSpy.isFocused ? 'focus' : ''}, "Here's To the Moonshots!"), 
        React.createElement("p", null, 
          "Thanks for tuning in! There are still many more topics to cover beyond this introduction: debt and debt" + " " +
          "discounts, tax implications of exercising options, valuation triggers, and many more."
        ), 
        React.createElement("p", null, 
          "Want more detail on a specific topic?  Was something confusing or not completely accurate?  Want to just send" + " " +
          "some love? (It's free.) ", React.createElement("a", {href: "https://twitter.com/floatrock", target: "blank"}, "@floatrock"), "."
        ), 
        React.createElement("p", null, 
          "Found a bug?  ", React.createElement("a", {href: "https://github.com/dlopuch/venture-dealr/issues"}, "File a bug"), "!"
        ), 
        React.createElement("p", null, 
          "A special thanks to everyone who gave early reviews, feedback, and suggestions: Ray, Dave, Sean, Kyan, Islam," + " " +
          "Adam, Connor, Jeff, and the whole crew" + " " +
          "at ", React.createElement("a", {id: "datahero2", href: "https://www.datahero.com", target: "_blank", "data-toggle": "tooltip", "data-placement": "bottom", 
                title: "Join our team to build more interactive visualizations like this!"}, "DataHero"), " for the" + " " +
          "original hackathon inspiration.  ", React.createElement("i", {className: "fa fa-heart"}, " ")
        ), 


        React.createElement("h3", {className: this.state.scrollSpy.isFocused ? 'focus' : ''}, "Coming Next: Venture Makr"), 
        React.createElement("p", null, 
          "Like what you saw?  Send some social love and encouragement for ", React.createElement("strong", null, "Venture Makr"), ": a full editor to" + " " +
          "create your own rounds with custom valuations and equity distributions.  Turn the knobs on your own creations and" + " " +
          "see how scenarios might unfold differently."
        ), 
        React.createElement("p", null, 
          "The numbers presented here have been made up for illustrative purposes only.  Although money raised is often" + " " +
          "publicly announced and recorded in places like Crunchbase, valuations are generally kept private.  If you" + " " +
          "know of any ventures — failed, successful, or otherwise — which have made their numbers publicly" + " " +
          "available, drop me a line and let's tell their story (or the story of what could have been)."
        ), 


        React.createElement("h3", {className: this.state.scrollSpy.isFocused ? 'focus' : ''}, "Always Tip Your Bartender"), 
        React.createElement("p", null, 
          "Team Beer: ", React.createElement("i", {className: "fa fa-btc"}), "1BVJ2Kyvo9Np6uiCooFm3XMhjgJMLUquZr"
        ), 
        React.createElement("p", null, 
          "Team Whiskey: ", React.createElement("i", {className: "fa fa-btc"}), "1MQvPwNWjqAD1RW5uCFBYfjtgQhfa2G9nK"
        )
      )
    );
  }
});


/** WEBPACK FOOTER **
 ** /Users/dlopuch/developer/projects-venture-dealr/~/jsx-loader?harmony!./views/scrollSpyContents/Credits.jsx
 **/